<template>
  <div>
    <!-- 附加服务 创建服务单专用 -->
    <el-dialog :title="$t('message.additionalServices')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="700px" center>
      <div class="option">
        <!-- 列表 -->
        <div class="table">
          <ol>
            <!--附加服务选择  -->
            <li class="flex15">
              {{ $t("message.additionalServiceOptions") }}
            </li>
            <!--附加服务日文  -->
            <li class="flex15">
              {{ $t("message.additionalServicesJapanese") }}
            </li>
            <!--数量  -->
            <li>
              {{ $t("message.number") }}
            </li>
            <!-- 收费 -->
            <li>
              {{ $t("message.charge") }}
            </li>
          </ol>
          <ul v-for="(item, index) in optionsList" :key="index">
            <!-- 附加服务选择  -->
            <li class="flex15">
              <div class="checkbox">
                <el-checkbox v-model="item.checked">({{ index + 1 }}) {{ item.name }}</el-checkbox>
              </div>
            </li>
            <!--附加服务日文  -->
            <li class="flex15">
              <span>{{ item.name_translate }}</span>
            </li>
            <!--数量  -->
            <li>
              {{ item.num }}
            </li>
            <!--实际收费标准  -->
            <li>
              {{ item.price }}
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      optionsList: [],
      extra_options: [],
      dialogVisible: false,
    };
  },
  methods: {
    // 保存
    save() {
      let extraOptions = []
      this.optionsList.forEach(item => {
        if (item.checked) {
          this.extra_options.forEach(extraItem => {
            if (extraItem.name == item.name) {
              // extraItem.complete = extraItem.should
              extraOptions.push(extraItem)
            }
          })
        }
      })

      this.$parent.saveOption(extraOptions);
      this.dialogVisible = false
    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  margin-bottom: 20px;
  // height: 650px;
  // overflow-y: auto;

  ol {
    display: flex;
    height: 40px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;

    li {
      height: 40px;
      text-align: center;
    }
  }

  ul {
    display: flex;
    padding: 10px 0;

    .total {
      width: 70%;
      text-align: center;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex2 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .checkbox {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;

    .input {
      width: 160px;
      margin-left: 10px;
    }
  }

  .template {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;

    .input {
      width: 140px;
      margin-right: 10px;
    }
  }
}

.operation {
  margin-top: 10px;


  .el-button {
    margin-right: 220px;
  }
}

.showList {
  transition: all 0.3s;
  height: 0;
  overflow: hidden;
}

.isShow {
  height: auto;

}
</style>